import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { StoresComponent } from './stores.component';
import { NbMenuItem } from '@nebular/theme';
import { ActionState, SelectedValue, UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { StoreComponent } from './store/store.component';

export const storeroutes: Routes = [
  {
    path: '',
    component: StoresComponent
  },
  {
    path: 'store',
    component: StoreComponent
  },
  {
    path: 'store/:productStoreId',
    component: StoreComponent,

  },
  {
    path: 'store/:productStoreId/catalogs',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Catalogs",
    }
  },
  {
    path: 'store/:productStoreId/paymentSettings',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Payment Settings",
    }
  },
  {
    path: 'store/:productStoreId/facilities',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Facilities",
    }
  },
  {
    path: 'store/:productStoreId/roles',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Roles",
    }
  },
  {
    path: 'store/:productStoreId/promotions',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Store Promotions",
    }
  },
  {
    path: 'store/:productStoreId/shipmentMethods',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Shipment Methods",
    }
  },
  {
    path: 'store/:productStoreId/shipmentCostEstimates',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Shipment Cost Estimates",
    }
  },
  {
    path: 'store/:productStoreId/financialAccountSettings',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Financial Account Settings",
    }
  },
  {
    path: 'store/:productStoreId/storeEmailSettings',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Store Email Settings",
    }
  },
  {
    path: 'store/:productStoreId/storeSurveys',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Store Surveys",
    }
  },
  {
    path: 'store/:productStoreId/vendorShipments',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Catalogs",
    }
  },
  {
    path: 'store/:productStoreId/vendorPaymentSettings',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Vendor Payment Settings",
    }
  },
  {
    path: 'store/:productStoreId/webSites',
    component: StoreComponent,
    data: {
      event: ActionState.RELATE,
      type: "Web Sites",
    }
  }

]

const listMenuData: SelectedValue = {
  event: "list",
  type: "ListProductStore",
  data: {
    formData: {
      formName: "ListProductStore",
      formLocation: "component://kwikstore/widget/StoreForms.xml"
    },
    appContext: "catalog",

  }
}

const MENU_ITEMS: NbMenuItem[] = [
  {
    title: "List Stores",
    icon: { icon: "list-outline", pack: 'eva' },
    link: "/admin/stores",
    data: listMenuData
  },
  {
    title: "New Store",
    icon: { icon: "plus-outline", pack: 'eva' },
    link: "/admin/stores/store",
    data: {
      event: ActionState.ADD
    }
  },
  { title: "Product Stores", group: true, icon: "grid-outline" }
];
const headerTitle: string = "Product Store Application";
const path: string = "stores";
const menuTag: string = "storesMenu"

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(storeroutes),
    UbsViewContainersModule
  ]
})
export class StoresRoutingModule {
  menuAndTitleOptions = { path: path, menuItems: MENU_ITEMS, headerTitle: headerTitle, menuTag: menuTag };
  constructor(private viewContainerService: ViewContainersService) {
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(), this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(menuTag);
    // this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)
  }


}
